import { useState, useEffect, useRef, useLayoutEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import { UiSelect, UiInput, TableZero, UiButton, BgLoader } from "../ui";
import Button from 'react-bootstrap/Button';

import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import { useNavigate, useLocation } from "react-router-dom";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { Helmet } from "react-helmet";


const Filter = NiceModal.create(
  ({ filters }) => {
    const [state, setState] = useState({});
    const [itemLoader, setItemLoader] = useState(false);

    const elementRef = useRef(null)
    const modal = useModal();
    const schema = yup.object().shape({

    });
    const {
      register,
      handleSubmit,
      control,
      unregister,
      watch,
      getValues,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const onSubmitHandler = async (data) => {
      const myParams = getValues()

      const u = new URLSearchParams(myParams).toString();
      modal.resolve({ 'filter': u });
      modal.hide();
      //reset();
    };


    const location = useLocation();



    const fetchItems = (districtValue) => {
      const queryString = filters;

      const params = new URLSearchParams(queryString);
      if (districtValue) {
        params.append("district1", districtValue);
      }

      const updatedQuery = params.toString();
      setItemLoader(true)
      instance
        .get("/load_filter.php?" + updatedQuery)
        .then(function (response) {
          setItemLoader(false)
          setState({ ...state, ...response.data })
          { response.data.values && reset(response.data.values) }


        })
        .catch(function (error) { })
        .then(function () { });
    }




    const clearFilter = () => {
      modal.resolve({ 'filter': '' });
      modal.hide();
    }

    const watchDistrict = watch("district");
    const watchCategory = watch("category");

    useEffect(() => {
      if (modal.visible == true) {
        modal.hide();
      }
    }, [location]);

    useEffect(() => {

      fetchItems()
    }, []);




    return (
      <>
        <Helmet>
        </Helmet>
        <Offcanvas placement="end" {...bootstrapDialog(modal)}>
          <Offcanvas.Header className="bg-light" closeButton>
            <Offcanvas.Title>Filter</Offcanvas.Title>
          </Offcanvas.Header>


          <Offcanvas.Body id="parentelm" className="p-0" ref={elementRef}>
            <>
              <>
                {state.category && (
                  <div className="position-relative">

                    <form id="filterform" onSubmit={handleSubmit(onSubmitHandler)}>
                      <div className="p-3">
                        <div className="mb-2"><b>Category</b></div>
                        <UiSelect
                          name="category"
                          //label="Category"
                          options={state.category ? state.category : []}
                          {...register(`category`)}
                        />
                        <div className="mb-2"><b>District</b></div>
                        <UiSelect
                          name="district"
                          //label="District"
                          options={state.district ? state.district : []}
                          {...register(`district`, { onChange: (e) => { fetchItems(e.target.value); } })}
                        />
                        {watchDistrict && <>
                          {state.area && state.area.length > 0 && <>
                            <div className="mb-2"><b>Area</b></div>
                            {state.area.map((item, index) => {
                              return <div className="form-input">
                                <input type="checkbox" className="form-check-input" id={item} value={item} {...register(`area`)} />
                                <label className="form-check-label ms-2" htmlFor={item}>
                                  {item}
                                </label>
                              </div>
                            })}
                          </>}
                        </>}
                        {watchCategory && watchCategory == 'Granite' && <>
                          {state.colors && <div>
                            <div className="mb-2"><b>Colors</b></div>
                            {state.colors.map((item, index) => {
                              return <div className="form-input">
                                <input type="checkbox" className="form-check-input" value={item.value} id={item.value} {...register(`color`)} />
                                <label className="form-check-label ms-2" htmlFor={item.value}>
                                  {item.label}
                                </label>
                              </div>
                            })}
                          </div>}
                        </>}
                      </div>
                      <div className="position-fixed bottom-0  p-3 bg-white border-top w-100">


                        <Button variant="warning" className="btn-lg" type="submit" style={{ width: "150px" }}>
                          Filter
                        </Button>
                        <Button variant="secondary" onClick={() => clearFilter()} className="ms-3 btn-lg">
                          Clear
                        </Button>
                      </div>
                    </form>

                  </div>
                )}
              </>
            </>

          </Offcanvas.Body>

        </Offcanvas>
      </>
    );
  }
);

export default Filter;
